// extracted by mini-css-extract-plugin
module.exports = {"f-AtomList":"List_f-AtomList__6Fq6V","f-AtomListBox":"List_f-AtomListBox__7Qn8N","f-AtomList--orientation-horizontal":"List_f-AtomList--orientation-horizontal__4HXev"};